<template>
  <div style="position: relative;">
    <div class="report-title">Gender-wise engagement driver's performance</div>
    <div v-if="isLoading" style="position: absolute;left:40%;top:30%;z-index: 99;">
      <v-btn :loading="true" text x-large fab></v-btn>
      <div class="pl-1">Loading...</div>
    </div>
    <div id="diversityDriverBar" class="driver-diversity-bar"></div>
  </div>
</template>

<script>
import 'amcharts3';
import 'amcharts3/amcharts/serial';
// import { mapState } from 'vuex';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';

am4core.useTheme(am4themes_animated);

export default {
  name: 'DiversityDriverBar',

  props: {
    barData: {
      reqiured: true,
      type: Object
    }
  },

  data () {
    return {
      driverBarData: [],
      isLoading: true
    };
  },

  watch: {
    barData: {
      deep: true,
      immediate: true,
      handler () {
        this.isLoading = true;
        this.formatDriverData();
      }
    }
  },

  beforeDestroy () {
    am4core.disposeAllCharts();
  },

  methods: {
    formatDriverData () {
      const temp = [];
      if (this.barData) {
        this.$lodash.each(this.barData, (val, key) => {
          const t = {};
          t.driver = key.replace(/([A-Z])/g, ' $1').trim();
          t.male = val.Male ? val.Male : undefined;
          t.female = val.Female ? val.Female : undefined;
          t.other = val.Other ? val.Other : undefined;
          temp.push(t);
        });
        this.driverBarData = temp;
        this.createDiversityDriverBarchart();
      }
    },
    createDiversityDriverBarchart () {
      am4core.useTheme(am4themes_animated);
      // Themes end

      // Create chart instance
      var chart = am4core.create('diversityDriverBar', am4charts.XYChart);

      chart.preloader.disabled = true;
      const that = this;
      chart.events.on('ready', function (ev) {
        that.isLoading = false;
      });

      // Add data
      chart.data = this.driverBarData;
      // [{
      //   year: 2005,
      //   income: 23.5,
      //   expenses: 18.1
      // }, {
      //   year: 2006,
      //   income: 26.2,
      //   expenses: 22.8
      // }, {
      //   year: 2007,
      //   income: 30.1,
      //   expenses: 23.9
      // }, {
      //   year: 2008,
      //   income: 29.5,
      //   expenses: 25.1
      // }, {
      //   year: 2009,
      //   income: 24.6,
      //   expenses: 25
      // }];

      // Create axes
      var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = 'driver';
      categoryAxis.renderer.grid.template.disabled = true;
      categoryAxis.renderer.line.strokeOpacity = 1;
      categoryAxis.renderer.line.strokeWidth = 1.5;
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 20;
      // categoryAxis.renderer.labels.template.rotation = 55;
      categoryAxis.renderer.cellStartLocation = 0.1;
      categoryAxis.renderer.cellEndLocation = 0.8;

      const label = categoryAxis.renderer.labels.template;
      label.dx = 0;
      label.wrap = true;
      label.maxWidth = 130;
      // label.wrap = true;
      // label.maxWidth = 60;

      // eslint-disable-next-line no-unused-vars
      var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.minGridDistance = 50;
      valueAxis.renderer.grid.template.disabled = true;
      valueAxis.renderer.line.strokeOpacity = 1;
      valueAxis.renderer.line.strokeWidth = 1.5;
      valueAxis.min = 1;
      valueAxis.max = 5;
      // Create series2
      var series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = 'male';
      series.dataFields.categoryX = 'driver';
      series.name = 'name';
      series.columns.template.fillOpacity = 1;
      series.strokeWidth = 0;
      // series.columns.template.fill = 'rgba(136, 106, 181, 1)';
      series.columns.template.fill = '#050550';
      // series.columns.template.tooltipHTML = `<center><strong>Overall: {categoryX}</strong></center>
      // <hr />
      // <table>
      // <tr>
      //   <th align="left">Chats Initiated</th>
      //   <td>{overallChatInitiated}</td>
      // </tr>
      // <tr>
      //   <th align="left">Chats Completed</th>
      //   <td>{overallChatCompleted}</td>
      // </tr>
      // </table>`;

      // Create series
      var series1 = chart.series.push(new am4charts.ColumnSeries());
      series1.dataFields.valueY = 'female';
      series1.dataFields.categoryX = 'driver';
      series1.name = 'name';
      series1.columns.template.fillOpacity = 1;
      series1.strokeWidth = 0;
      // series1.columns.template.fill = 'rgba(190, 174, 215, 1)';
      series1.columns.template.fill = '#810052';
      // series1.columns.template.tooltipHTML = `<center><strong>Male: {categoryX}</strong></center>
      // <hr />
      // <table>
      // <tr>
      //   <th align="left">Chats Initiated</th>
      //   <td>{maleChatInitiated}</td>
      // </tr>
      // <tr>
      //   <th align="left">Chats Completed</th>
      //   <td>{maleChatCompleted}</td>
      // </tr>
      // </table>`;

      // Create series1
      var series2 = chart.series.push(new am4charts.ColumnSeries());
      series2.dataFields.valueY = 'other';
      series2.dataFields.categoryX = 'driver';
      series2.name = 'name';
      series2.columns.template.fillOpacity = 1;
      series2.strokeWidth = 0;
      series2.columns.template.fill = '#818385';
      // series2.columns.template.fill = 'rgba(163, 140, 198, 1)';
    }
  }
};
</script>

<style lang="scss" scoped>
.report-title {
  text-align: center;
  position: relative;
  top: 10px;
  color: var(--color-text);
  font-size: var(--heading-size);
  font-weight: var(--heading-weight);
}
.driver-diversity-bar {
  width: 100%;
  height: 510px;
  // height: 100%;
}
</style>
